import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Table } from 'primeng/table';

import { GerenciarPerfisUsuariosApiService } from '../../services/gerenciar-perfis-usuarios-api.service';
import { Usuario } from '../../models/usuario';
import { UsuarioStatus, UsuarioStatusNomeMap } from '../../../../../shared/models/enums/usuario-status';
import { MessageService } from '@services/message.service';
import { DialogConfirmacaoComponent } from '@components/dialog-confirmacao/dialog-confirmacao.component';
import { TrocarSenhaUsuarioDialogComponent } from './trocar-senha-usuario-dialog/trocar-senha-usuario-dialog.component';
import { Permissao } from '@models/enums/permissao';

@Component({
  selector: 'app-lista-usuarios',
  templateUrl: './lista-usuarios.component.html',
  styleUrl: './lista-usuarios.component.scss',
  standalone: false,
})
export class ListaUsuariosComponent {

  @Input() usuarios: Usuario[] = [];
  @Output() usuariosChange = new EventEmitter<Usuario[]>();
  @ViewChild('dt') table!: Table;

  readonly UsuarioStatus = UsuarioStatus;
  readonly usuarioStatusNomeMap = UsuarioStatusNomeMap;
  readonly Permissao = Permissao;

  constructor(
    private gerenciarPerfisUsuariosApiService: GerenciarPerfisUsuariosApiService,
    private messageService: MessageService,
    private dialog: MatDialog,
  ) { }

  public getStatusNome(status: UsuarioStatus): string {
    return this.usuarioStatusNomeMap.get(status) ?? '';
  }

  public aprovarUsuarioClick(usuario: Usuario): void {
    this.openConfirmacaoDialog(usuario, 'Aprovar', "#4A6572", () => this.aprovarUsuario(usuario));
  }

  public rejeitarUsuarioClick(usuario: Usuario): void {
    this.openConfirmacaoDialog(usuario, 'Rejeitar', "#F44336", () => this.rejeitarUsuario(usuario));
  }

  private openConfirmacaoDialog(usuario: Usuario, nomeAcao: string, btnColor: string, funcao: () => void): void {
    const dialogRef = this.dialog.open(DialogConfirmacaoComponent, {
      width: '467px',
      panelClass: 'no-padding-dialog',
      autoFocus: false
    });
    dialogRef.componentInstance.titulo = `${nomeAcao} o cadastro`;
    dialogRef.componentInstance.mensagemBold = `${nomeAcao} o pedido de cadastro do usuário ${usuario.login}`;
    dialogRef.componentInstance.textoBtnConfirmacao = nomeAcao;
    dialogRef.componentInstance.btnBackgroundColor = btnColor;
    dialogRef.componentInstance.acaoConfirmacao = funcao;
  }

  private aprovarUsuario(usuario: Usuario): void {
    this.gerenciarPerfisUsuariosApiService.aprovarUsuario(usuario.id).subscribe({
      next: () => {
        this.messageService.showToastSuccess(`Usuário "${usuario.login}" aprovado com sucesso.`);
        this.usuariosChange.emit(this.usuarios.map(u =>
          u.id === usuario.id ? { ...u, status: UsuarioStatus.Autorizado } : u
        ));
      }
    });
  }

  private rejeitarUsuario(usuario: Usuario): void {
    this.gerenciarPerfisUsuariosApiService.rejeitarUsuario(usuario.id).subscribe({
      next: () => {
        this.messageService.showToastSuccess(`Cadastro de "${usuario.login}" recusado.`);
        this.usuariosChange.emit(this.usuarios.filter(u => u.id !== usuario.id));
      }
    });
  }

  public trocarSenhaClick(usuario: Usuario): void {
    const dialogRef = this.dialog.open(TrocarSenhaUsuarioDialogComponent, {
      width: '540px',
      panelClass: 'no-padding-dialog',
      autoFocus: false,
    });
    dialogRef.componentInstance.usuario = usuario;

    dialogRef.afterClosed().subscribe((alterado: boolean | null) => {
      if (alterado) {
        this.usuariosChange.emit(this.usuarios.map(u =>
          u.id === usuario.id ? { ...u, status: UsuarioStatus.Autorizado } : u
        ));
      }
    });
  }

  public filtrar(valor: string) {
    this.table.filterGlobal(valor, 'contains');
  }
}
